<template>
    <div class="toggle-block"  :class="{'close': close }">
        <span @click="toggleClose" class="toggle-close" >
            <img :src="arrowImg" :style="{transform: 'rotate('+arrowRotate+'deg)'}" alt="">
        </span>
        <div class="toogle-title">
            <slot name="toogle-title"></slot>
        </div>
        <div class="toogle-body">
            <slot name="toogle-body"></slot>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            arrowImg: require('@/assets/img/icon/arrow_up_orange.svg'),
            arrowRotate: '0',
            close: this.isClose
        }
    },
    props:{
        isClose: {
            default: false,
            type: Boolean
        }
    },
    watch: {
        close: function () {
            if(this.close){
                this.arrowImg = require('@/assets/img/icon/arrow_up_orange.svg'),
                this.arrowRotate = '180'
            }else{
                this.arrowImg = require('@/assets/img/icon/arrow_up_orange.svg'),
                this.arrowRotate = '0'
            }
        },
    },
    methods: {
        toggleClose: function () {
            this.close = !this.close
        },
    }
}
</script>
<style lang="scss"  >
    .toggle-block{
        position: relative;
        width: 1140px;
        border-radius: 6px;
        border: solid 1px #f3f3f3;
        background-color: #ffffff;
        box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
        margin-bottom: 20px;
        .toggle-close{
            position: absolute;
            right: 20px;
            top: 24px;
            cursor: pointer;
        }
        >.toogle-title{
            display: flex;
            align-items: center;
            font-size: 20px;
            padding: 24px;
            color: #ff9275;
            >img{
                margin-right: 4px;
            }
            .toogle-title{
                display: flex;
                align-items: center;
            }
            .title-group{
                display: flex;
                align-items: center;
            }
        }
        >.toogle-body{
            padding: 0 24px 24px 24px;
        }
    }
    .toggle-block.close{
        .toogle-body{
            display: none;
        }
    }
    @media screen and (max-width: 1280px) {
        .toggle-block{
            width: 100%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tools/toogleBlock.vue